/**
 * 商城显示
 */
import { makeAutoObservable, runInAction } from 'mobx'
import { restaurantCenter, productMobx, RESTAURANT_EVENT, favoMobx, mallInit, shopcartMobx } from '@mobx/mall'
import ProductAPI from 'api/mallProduct.api'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import mallChangeController from '@ctrls/mallChangeController'
import { restaurantConfig } from 'restaurant'

// 餐品排序
const sortPoucts = (categoryNo: string | undefined, products: IMallViewProduct[]) => {
  if (categoryNo === '') {
    return products
  }
  if (categoryNo) {
    const productSortMap: any = {}
    products.forEach((p) => {
      const sort = p.sortInCategory[categoryNo] || 1
      productSortMap[p.no] = sort
    })
    // 排序的数据可能并不完整（有新增的餐品等，这时需要一个辅助变量来保证每次排序是可控的）
    products.sort((a, b) => (productSortMap[b.no] !== undefined ? productSortMap[b.no] : b.id) * 100000 - (productSortMap[a.no] !== undefined ? productSortMap[a.no] : a.id) * 100000)
  }
  return products
}

// 全部商品类别下排序
const sortAllProduct = (products: IMallViewProduct[]) => {
  const allProductSort = productMobx.allProductSort

  let productList: any[] = []
  if (products.length && allProductSort?.length) {
    let sortProductList: any[] = []
    let noSortProductList: any[] = []
    let flag = false
    allProductSort.forEach(item => {
      products.forEach(product => {
        if (item === product.no) {
          sortProductList.push(product)
        }
      })
    })
    if (sortProductList.length < products.length) {
      products.forEach(product => {
        flag = false
        sortProductList.forEach(item => {
          if (item.no === product.no) {
            flag = true
          }
        })
        if (!flag) {
          noSortProductList.push(product)
        }
      })
    }
    productList = sortProductList.concat(noSortProductList)
  }
  return productList.length ? productList : products
}

class Mall {
  constructor () {
    makeAutoObservable(this)
    restaurantCenter.on(restaurantCenter.RESTAURANT_EVENT.RESTAURANT_INIT, () => {
      this.init()
    })
  }
  /** 是否初始化 */
  isInited: boolean = false
  /** 点餐页滚动轴Y的高度 */
  mallScrollTop: number = 0
  /** 当前选中的菜单no */
  selectCategoryNo: string = ''
  selectCategoryId: number = 0
  /** 商城正在加载中 */
  isLoading = false
  /** 商城加载失败 */
  isError = false
  /** 延迟滚动加载图片支持 */
  imgLoadingMap: { [no: string]: boolean } = {}
  brandId = Config.BRANDID
  /** 分组置顶列表 */
  brandProductTopList: IMallCategoryTop[] = []

  /** 聚合后的餐品展示餐品的数据 */
  get brandProductTop () {
    return this.getBrandProductTopMap[this.selectCategoryId]
  }
  // TODO 将查询结果分离出这个结果中
  /** 聚合后的餐品展示餐品的数据 */
  get products () {
    // 如果是瀑布流则不指定分类显示全餐品，而category类型不指定则显示默认第一个分类
    let products: IMallViewProduct[] = []
    products = productMobx.viewProducts
    if (!this.selectCategoryNo) {
      products = sortAllProduct(products)
    } else {
      products = this.categories.find(category => category.no === this.selectCategoryNo)?.products || []
      products = sortPoucts(this.selectCategoryNo, products)
    }

    return products
  }
  /** 聚合后的餐品展示分类的数据 */
  get categories () {
    return productMobx.categories.map(category => {
      return { ...category, products: productMobx.categoryNoToViewProductsMap[category.no] || [] } as IMallCategory
    })
  }
  /** 初始化 */
  async init () {
    this.isLoading = true
    this.selectCategoryNo = ''
    this.selectCategoryId = 0

    mallInit()
    await this.getBrandProductTop()
    await productMobx.init()
    favoMobx.init()
    shopcartMobx.init()
    setTimeout(() => {
      mallChangeController.menuSwitchEatType('mall')
      restaurantConfig.mpc.switchEatType('mall')
      restaurantCenter.emit(RESTAURANT_EVENT.MENU_END)
      restaurantCenter.emit(RESTAURANT_EVENT.MENU_MALL_CHANGE)
    }, 500)
    runInAction(() => {
      this.isInited = true
      this.isLoading = false
    })
  }

  /** 选择分类 */
  selectCategory (category: ICategory | string = '') {
    if (typeof category === 'string' || typeof category === 'undefined') {
      this.selectCategoryNo = category
      this.selectCategoryId = 0
    } else {
      this.selectCategoryNo = category.no
      this.selectCategoryId = category.id
    }
  }
  // 设置点餐页滚动距离
  setMallScrollTop (hst: number) {
    if (this.mallScrollTop !== hst) {
      this.mallScrollTop = hst
    }
  }
  /**
   * 获取显示分组置顶商品列表
   */
  async getBrandProductTop () {
    const { result = [] }: any = await ProductAPI.getBrandProductTop()
    runInAction(() => {
      this.brandProductTopList = result
      return result
    })
  }
  get getBrandProductTopMap () {
    return keyBy(this.brandProductTopList || [], item => item.productCategoryId)
  }

  /** 设置配置 */
  setConfig (scfg, nfig?: any) {
    restaurantCenter.setConfig(scfg, nfig)
  }

  /** 设置商城加载状态 */
  setIsLoading (isLoading: boolean) {
    this.isLoading = isLoading
    if (isLoading) {
      this.isError = false
    }
  }
  /** 设置商城加载错误状态 */
  setIsError (isError: boolean) {
    this.isError = isError
    this.isLoading = false
  }
  /** 设置图片延迟加载以加载的数据 */
  setImgLoading (no: string) {
    this.imgLoadingMap[no] = true
  }
}

export default new Mall()
